import React, { useContext } from "react";
import styles from "./NavBar.module.css";
import coopnav from "../../img/coopnav.png";
import imgback from "../../img/fondo-tramite2.png";
import { AppContext } from "../../context/context";
import UserMenu from "../userMenu/userMenu";
import OffCanvasMenu from "../offcanvas/offcanvas";

const NavBar = () => {
  const { isLogin } = useContext(AppContext);

  return (
    <>
      <div className={styles.navContainer}>
        <div className={styles.content}>
          {isLogin && <OffCanvasMenu />}
          <a href="/coop">
            <img src={coopnav} alt="" />
          </a>
          {isLogin && <UserMenu />}
        </div>
      </div>
      <div className={styles.imgBackContainer}>
        <img src={imgback} className={styles.imgBack} />
        <p className={styles.title}>Realizá tus trámites de manera Online</p>
      </div>
    </>
  );
};
export default NavBar;
